import React from 'react';
import cn from 'classnames';

import { IMG_TINT_ATTR } from 'common/constants';
import { BBCommonProps } from 'types/story';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';
import css from './Img.scss';

type Props = BBCommonProps;

class Img extends React.Component<Props> {
	renderEditable() {
		const props = { ...this.props.editableModeProps?.nodeProps };
		return this.renderDefault(props);
	}

	renderDefault(props: any = {}) {
		const { stateAttrs, eventListeners } = this.props;
		const { nodeProps } = this.props.uiConfig;
		const className = cn(css.img, nodeProps.className, props.className);

		return (
			<div {...nodeProps} {...stateAttrs} {...eventListeners} {...props} className={className}>
				<span {...{ [IMG_TINT_ATTR]: '' }} />
			</div>
		);
	}

	render() {
		return this.props.isEditableMode ? this.renderEditable() : this.renderDefault();
	}
}

export default withCardTransitionContext(Img);
